import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[cubeDynamic]',
  standalone: false,
})
export class DynamicDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
